<script>
  import APIClient from '../../state-charts/api-client';

  import InputWithValidation from '../../lib/components/InputField.svelte';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import { show_message } from '../../lib/flash';
  import session from '../../lib/session';
  import Selector from '../../lib/components/Selector.svelte';

  export let load_documents;
  export let documents;
  export let is_edit = false;
  export let document_edit;

  let labels = {
    dialog: {
      title: null,
      content: null,
      title_edit: null,
    },
    btn_cancel: null,
    btn_yes: null,
    tooltip: null,
    title: null,
    add_document: null,
    btn_back: null,
    btn_save: null,
    btn_close: null,
    btn_add: null,
  };

  let invalid_img = t9n(TS.CHAT_INVALID_IMG);

  let input = {
    file: null,
    message: null,
    type: null,
    extension: null,
  };

  let dialog;
  let value;
  let document_types = [];
  let is_uploaded = false;
  let disabled = false;
  let edit_image;
  let wait_api = false;

  const get_img_url = url => {
    return `${location.origin}${url}`;
  };
  const init_dialog = () => {
    document_types = $session.merchant.document_types;
    document_types.forEach(value => {
      value.val = value.document_type;
      value.name = get_docu_type_str(value.document_type);
    });

    let docu_types = [];

    for (let i = 0; i < document_types.length; i++) {
      let is_exist = false;
      for (let j = 0; j < documents.length; j++) {
        if (document_types[i].document_type === documents[j].document_type) {
          is_exist = true;
        }
      }
      if (!is_exist) docu_types.push(document_types[i]);
    }

    dialog = new MDCDialog(document.getElementById(`dialog-doc`));

    if (is_edit) {
      input.type = document_edit.document_type;
      input.message = document_edit.message;
      edit_image = document_edit.image_url;
    } else {
      document_types = docu_types;
    }
  };

  const upload_document = async () => {
    wait_api = true;
    let data = {
      document_type: input.type,
      data: input.file,
      extension: input.extension,
      message: input.message,
    };
    let result = await APIClient.upload_document(data);
    wait_api = false;
    if (!!result) {
      close();
      load_documents();
    }
  };

  const edit_document = async () => {
    wait_api = true;
    let data;
    if (!!input.file) {
      data = {
        document_type: input.type,
        data: input.file,
        extension: input.extension,
        message: input.message,
      };
    } else {
      data = {
        document_type: input.type,
        message: input.message,
      };
    }

    let result = await APIClient.edit_document(data);
    wait_api = false;
    if (!!result) {
      close();
      load_documents();
    }
  };

  export const open = () => {
    dialog.open();
  };

  export const close = () => {
    dialog.close();
  };

  const get_docu_type_str = docu_type => {
    let docu = document_types.filter(
      value => value.document_type === docu_type
    )[0];
    let lang = $session.language;
    switch (lang) {
      case 'ar':
        return docu.localized_names.translation_ar;
      case 'en':
        return docu.localized_names.translation_en;
      case 'fa':
        return docu.localized_names.translation_fa;
      case 'fi':
        return docu.localized_names.translation_fi;
      case 'ru':
        return docu.localized_names.translation_ru;
      case 'sv':
        return docu.localized_names.translation_sv;
      case 'uk':
        return docu.localized_names.translation_uk;
    }
  };

  const open_upload_pic_dialog = () => {
    let elem = document.getElementById('input-button');
    if (elem && document.createEvent) {
      let evt = document.createEvent('MouseEvents');
      evt.initEvent('click', true, false);
      elem.dispatchEvent(evt);
    }
  };

  const load_file = () => {
    input.file = document.querySelector('input[type=file]').files[0];
    let reader = new FileReader();

    reader.onload = e => {
      if (input.file.size > 2097152) {
        show_message(invalid_img, 'error');
        document.querySelector('input[type=file]').value='';
      } else {
        is_uploaded = true;
        let img = document.getElementById('img-uploaded');
        img.setAttribute('src', e.target.result);
        input.extension = input.file.name.split('.')[1];
        input.extension = input.extension.toLowerCase();
        input.file = e.target.result.split(',')[1];
      }
    };

    if (input.file) {
      reader.readAsDataURL(input.file);
    }
  };

  const is_disabled = (file, message, type) => {
    if (!is_edit) {
      disabled =
        file === null ||
        file.length === 0 ||
        type === null ||
        type.length === 0;
    } else {
      disabled = type === null || type.length === 0;
    }
  };

  $: is_disabled(input.file, input.message, input.type);

  onMount(init_dialog);
</script>

<div id="dialog-doc" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      style="overflow: visible">

      <h2 class="mdc-dialog__title" id="doc-title">
        {#if !is_edit}
          {t9n(TS.DOCUMENTS_ADD)}
        {:else}{t9n(TS.DOCUMENTS_EDIT)}{/if}

      </h2>

      <div
        class="mdc-dialog__content"
        id="doc-content"
        style="overflow: unset; max-height: 460px">

        <!-- Help line -->
        <div id="help-liner" class="">
          <div class="tooltip-default ">
            <span id="tooltip_def" class="tooltip-text tooltip-top">
              {t9n(TS.DOCUMENTS_DIALOG_TOOLTIP)}
            </span>
          </div>
        </div>

        <div
          style="margin-left: 0px; margin-top: 10px; align-content: center;
          text-align: center;">
          <div>
            <!-- if not uploaded this icon, if uploaded doc <img> + status <p> -->
            {#if !is_edit}
              {#if !is_uploaded}
                <i
                  class="material-icons"
                  style="color:lightgray; font-size: 166px">
                  post_add
                </i>
                <br />
              {:else}{/if}

              <img id="img-uploaded" src="" width="410" />
            {:else}
              {#if !is_uploaded}
                <img src={get_img_url(edit_image)} width="410" />
              {:else}{/if}

              <img id="img-uploaded" src="" width="410" />
            {/if}

            <!-- :else -->
            <!-- <img src=""-->
            <!--      alt="">-->
            <!-- <p> status </p> -->
          </div>

          <!-- if not uploaded add photo else edit photo -->
          <button
            class="mdc-button mdc-button--outlined mdc-ripple-upgraded"
            id="open-file-uploader"
            on:click={() => open_upload_pic_dialog()}
            style="margin-bottom: 25px;">
            <span class="mdc-button__label">{t9n(TS.DOCUMENTS_ADD_PHOTO)}</span>
          </button>

          <div style="">
            <InputWithValidation
              id="opt-message"
              type="tasks"
              label={t9n(TS.DOCUMENTS_ADD_MESSAGE)}
              name="task"
              max_char="160"
              bind:value={input.message}
              width="410px" />
          </div>

          {#if !is_edit}
            <div class="native-sel-width">
              <Selector
                id="category-select"
                label={t9n(TS.DOCUMENTS_ADD_TYPE)}
                variant={'outlined'}
                is_required={true}
                validate={false}
                bind:items={document_types}
                bind:value={input.type} />
            </div>
          {/if}

        </div>
      </div>

      <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>

      <footer class="mdc-dialog__actions">
        <button
          on:click={() => close()}
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.TXT_CANCEL)}
        </button>

        {#if !is_edit}
          <button
            disabled={disabled || wait_api}
            style="margin-left: 10px;"
            on:click={async () => { await upload_document() }}
            data-mdc-dialog-initial-focus
            class="btn-close mdc-button mdc-button--unelevated">
            <span class="mdc-button__ripple" />
            {t9n(TS.ORDERER_TEAMS_ADD_LABEL)}
          </button>
        {:else}
          <button
            disabled={disabled || wait_api}
            style="margin-left: 10px;"
            on:click={async () => { await edit_document()} }
            data-mdc-dialog-initial-focus
            class="btn-close mdc-button mdc-button--unelevated">
            <span class="mdc-button__ripple" />
            {t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL)}
          </button>
        {/if}

      </footer>
    </div>
  </div>
  <div class="mdc-dialog__scrim" />
</div>

<input
  type="file"
  id="input-button"
  on:change={() => load_file()}
  accept="image/*,application/pdf"
  style="display: none;" />

<style>
    .required{
        font-size: 10pt;
        margin-left: 25px;
        margin-top: -5px;
        color: #323232;
    }

    .mdc-dialog__container {
      height: auto !important;
    }

    .mdc-dialog__surface {
      width: 450px;
    }

    .mdc-layout-grid {
      padding: 0;
    }

  /* Tooltip
    *******************************************************/

  .tooltip-default {
    position: relative;
    font-size: 12px;
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 33px;
    right: 40px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .fade-in-long {
    animation: transition_in 2.5s;
  }

  img {
    max-height: 20vh;
    object-fit: scale-down;
    width: -webkit-fill-available;
    width: -moz-available;
    width: fill-available;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .margin-50 {
      margin-left: 50px;
    }

    .padding-50 {
      padding-left: 50px;
    }

    .native-sel-width {
      width: 410px !important;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    /*.mdc-dialog__surface {*/
    /*    height: 100%;*/
    /*}*/
    .margin-50 {
      margin-left: 50px;
    }

    .padding-50 {
      padding-left: 50px;
    }

    .native-sel-width {
      width: 100% !important;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .margin-50 {
      margin-left: 1px;
    }

    .padding-50 {
      padding-left: 1px;
    }

    .native-sel-width {
      width: 100% !important;
    }

  }
</style>
